import { EquatableKeyStackItem } from './EquatableKeyStackItem';
export class ValidatorStackItem extends EquatableKeyStackItem {
    asValidator() {
        return this.value;
    }
}

//# sourceMappingURL=ValidatorStackItem.js.map
